import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { ScrollToTop } from './ScrollToTop';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="min-h-screen flex flex-col bg-white" data-id="element-80">
      <ScrollToTop data-id="element-81" />
      {/* Eyebrow Section */}
      <div className="bg-brand-dark text-white py-2 px-4 text-center" data-id="element-82">
        <p className="text-xs md:text-sm text-gray-300 max-w-7xl mx-auto leading-relaxed" data-id="element-83">
          Professional-grade electric sprayers for contractors in mold
          remediation, sanitation, restoration, and facilities
          maintenance—designed to spray faster, safer, and without pumping or
          hauling chemicals.
        </p>
      </div>
      <Header data-id="element-84" />
      <main className="flex-grow" data-id="element-85">{children}</main>
      <Footer data-id="element-86" />
    </div>;
}